<template>

    <div class="ui-spinner" :class="classes">
        <div class="spinner"></div>
    </div>

</template>

<script lang="ts">

import { Component, Prop, Vue } from 'vue-facing-decorator';

import type { ComponentProps } from '@wittignl/js-core';
import { createComponentMixin } from '@wittignl/js-core';

@Component({
    name: 'ui-spinner'
})
export default class Spinner extends Vue {

    @Prop({ type: [Boolean, Number, Object] })
    visible: boolean | number | any;

    @Prop({ type: Boolean, default: false })
    overlay: boolean;

    @Prop({ type: String })
    size: string;

    get classes() {

        const classes = [];

        if(this.visible){
            classes.push('visible');
        }

        if(this.overlay){
            classes.push('overlay');
        }

        if(this.size){
            classes.push(this.size);
        }

        return classes;
    }
}

export type SpinnerComp = InstanceType<typeof Spinner>
export type SpinnerProps = ComponentProps<SpinnerComp>
export const spinnerCompMixin = createComponentMixin(Spinner)

</script>
<style src="../../../scss/component/ui/Spinner.scss" lang="scss"></style>